import styled from 'styled-components';
import addicon from './images/adduser.svg';
import search from './images/lupa.svg';
import rightbg from './images/right-bg.png';
import icoedit from './images/icoedit.svg';
import icotrash from './images/close-ico.svg';
import moreIcon from './images/more-icon.svg';
import moreIconActive from './images/more-icon-active.svg';

export const Wrapper = styled.main`
  @media (max-width: 600px) {
    padding: 20px;
  }
  padding: 30px 50px 30px;
  position: relative;
  &::after {
    content: url(${rightbg});
    position: absolute;
    right: 0;
    top: 0;
    z-index: -2;
    @media (max-width: 768px) {
      content: none;
    }
  }
  .overlay {
    background-color: black;
    width: 100%;
    height: 100%;
    content: "";
    position: fixed;
    left: 0;
    top: 0;
    opacity: 0.3;
    cursor: pointer;
  }
`;

export const AddPatient = styled.button`
  width: 39px;
  height: 39px;
  cursor: pointer;
  background-image: url(${addicon});
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  background-color: transparent;
  border: none;
`;

export const Header = styled.div`
  text-align: center;
  position: relative;
  padding-bottom: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  h1 {
    color: #000000;
    font-family: "hn-semibold", Arial;
    font-size: 25px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: 35px;
    margin: 0;
    @media(max-width: 520px) {
      font-size: 18px;
      line-height: 25px;
    }
  }
`;

export const Searcher = styled.div`
  text-align: center;
  height: 60px;
  input {
    position: relative;
    background-image: url(${search});
    background-position: right 14px;
    background-repeat: no-repeat;
    border-width: 0 0 1px 0;
    border-color: #4a4a4a;
    background-color: transparent;
    padding: 18px 40px 0px 0;
    width: 100%;
    max-width: 400px;
    font-size: 14px;
    line-height: 26px;
    &::placeholder {
      color: #979da2;
      opacity: 1;
    }
  }
  input:focus-within {
    border-width: 0 0 1px 0;
    outline: none;
  }
  &::before {
    content: "";
    background-color: #f2f2f2;
    width: 100%;
    position: absolute;
    left: 0;
    height: 60px;
    border-bottom: 1px solid #e2e2e2;
  }
`;

export const Results = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

export const ResultsContainer = styled.div`
  overflow-x: auto;
  min-height: 200px;
  padding-bottom: 100px;
`;

export const Patient = styled.tr`
  border-bottom: 1px solid #e2e2e2;
  color: #000000;
  font-family: "hn-light", Arial;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0.36px;
  line-height: 22px;
  text-align: left;
  cursor: pointer;
  td {
    padding: 15px 10px;
  }
  :hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
`;

export const Actions = styled.div`
  text-align: right;
  width: 22px;
  position: relative;
  span {
    background: #fff url(${moreIcon}) no-repeat center;
    width: 22px;
    height: 22px;
    display: block;
    cursor: pointer;

    :hover,
    &.active {
      background: #fff url(${moreIconActive}) no-repeat center;
    }

  }
  ul {
    display: "none";
    position: absolute;
    z-index: 1;
    border-radius: 10px;
    padding: 15px 0px;
    background: #f2f2f2;
    border: 1px solid #e2e2e2;
    width: 208px;
    left: -10px;
    margin-top: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

    &::after,
    &::before {
      bottom: 100%;
      left: 20px;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &::after {
      border-color: rgba(242, 242, 242, 0);
      border-bottom-color: #f2f2f2;
      border-width: 5px;
      margin-left: -5px;
    }

    &::before {
      border-color: rgba(226, 226, 226, 0);
      border-bottom-color: #e2e2e2;
      border-width: 6px;
      margin-left: -6px;
    }

    li:first-child {
      border-top: 1px solid #e2e2e2;
    }

    li {
      border-bottom: 1px solid #e2e2e2;
      list-style: none;
      text-align: left;
      color: #000000;
      font-family: "hn-medium", Arial;
      font-size: 12px;
      font-weight: 400;
      font-style: normal;
      letter-spacing: 0.31px;
      line-height: 20px;
      padding: 12px 33px;
      padding-left: 45px;
      cursor: pointer;
    }

    li.icotrash {
      background: white url(${icotrash}) no-repeat 20px 11px;
    }

    li.icoedit {
      background: white url(${icoedit}) no-repeat 20px 14px;
    }

  }

  .icotrash {
    background: url(${icotrash}) no-repeat center right;
    cursor: pointer;
    width: 100%;
    background-size: contain;
  }
  .icoedit {
    background: url(${icoedit}) no-repeat center left;
    cursor: pointer;
    width: 14px;
    width: 100%;
  }

`;
export const BottomCTAsWrapper = styled.section`
  @media print {
    display: none;
  }
  background-color: white;
  width: 100%;
  display: grid;
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const ProtocolsCTAs = styled.span`
  padding: 10px 15px;
  color: #000000;
  font-family: "hn-semibold", Arial;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: normal;
  line-height: 20px;
  text-align: center;
  border: 1px solid #000000;
  max-width: 250px;
  align-self: center;
  justify-self: center;
  cursor: pointer;
  text-transform: lowercase;
  max-width: 285px;
  width: 100%;
  border: 1px solid #000000;
  background-color: #000000;
  color: #ffffff;
  margin: 30px auto 40px;
  display: block;
  @media (min-width: 1100px) {
    &:hover {
      text-decoration: underline;
    }
  }
    
`;